export default __webpack_public_path__ + "static/media/best.9db11ae8.svg";